export default function (ctxInfo) {
  // 根据$ctx是否为undefined判断环境是处于服务端还是客户端
  if (typeof $ctx === 'undefined' && !ctxInfo) {
    return navigator.userAgent; // 客户端逻辑，这段代码不会在服务端运行
  } else if (typeof $ctx !== 'undefined') {
    return $ctx.req.headers['user-agent'] || ''; // 服务端逻辑
  } else {
    return (ctxInfo === null || ctxInfo === void 0 ? void 0 : ctxInfo.userAgent) || '';
  }
}